import { BrowserModule } from '@angular/platform-browser';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { AppMaterialModules } from './material.module';
import { AppComponent } from './app.component';
import { AppLayoutComponent, AboutUsDialogComponent, ChangePasswordDialogComponent } from '../pages/app-layout/app-layout.component';
import { LoginComponent } from '../pages/login/login.component';

import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpModule } from '@angular/http';
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingModule } from './app-routing.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { CustomTranslateService } from '../providers/customTranslate.service';
import { LocalizedCurrencyPipe } from '../pipes/localizedCurrency.pipe';
import { LocalizedDatePipe } from '../pipes/localizedDate.pipe';
import { ServiceFactory } from '../providers/service.factory';
import { DialogComponent } from '../components/dialogbox/dialogbox.component';
import { LoaderComponent } from '../components/loader/loader.component';
import { LoginService } from '../providers/login.service';
import { CommonService } from '../providers/common.service';

import { ApiObservablefactory } from '../providers/observable.factory';
import { ApiPromisefactory } from '../providers/promise.factory';

import { ModelDialogComponent } from '../components/dialog/dialog.component';
import {MatTableModule} from '@angular/material/table';

import { SettingsService } from '../providers/settings.service';
import { DBService } from '../providers/indexedDB/db.service';
import { LOCALE_ID } from '@angular/core';
import 'hammerjs';
import { environment } from '../environments/environment.prod';

import { Constants } from '../common/constants';
import { DialogService } from '../providers/dialogservice';
import { ExampleCardlessComponent } from '../pages/examplecardless/example-cardless-module';
import { ExampleCashlessComponent } from '../pages/examplecashless/example-cashless-module';

import { GetStartedComponentQR } from '../pages/getstartedmoduleqr/getstartedmoduleqr';
import { GetStartedBLEComponent } from '../pages/getstartedmoduleble/getstartedmoduleble';

import { ClassModuleComponent } from '../pages/bleclassmodule/bleclassmodule';
import { DownloadsComponent } from '../pages/downloads/downloads';
import { IntroductionComponent } from '../pages/introductionmodule/introductionmodule';
import { EnumModuleComponent } from '../pages/enummodule/enummodule';
import { MethodServiceJava } from '../providers/methodsService.java';
import { MethodServiceSwift } from '../providers/methodsService.swift';
import { MatIconModule } from '@angular/material/icon';
import { EnumService } from '../providers/enumService';
import { MethodServiceCordova } from '../providers/methodsService.cordova';
import { LanguageSettings } from '../providers/languageSettings.service';
import { CodePipe } from '../pipes/code.pipe';
import { DecorateDirective } from '../directives/decorate.directive';
import { SearchDataService } from '../providers/searchDataService';
import { SearchBarComponent } from '../pages/searchbarcomponent/searchbar.component';
import { RouterModule } from '@angular/router';
import { CopytoclipDirective } from '../directives/copytoclip.directive';
import { SnackMessageComponent } from '../pages/SnackMessageComponent/copy.snack.component';
import { ExampleAdvancedComponent } from '../pages/example-advanced/example-advanced-module';
import { RSSITablePage } from '../pages/rssitablemodule/rssi-table-page';
import { LandingModuleComponent } from '../pages/landingmodule/landingmodule.component';
import { GetStartedEdgeComponent } from '../pages/getstarted-edge-module/getstartededgemodule';
import { ExampleCashlessEdgeComponent } from '../pages/examplecashlessedge/example-cashlessedge-module';
import { MethodServiceDart } from '../providers/methodsService.dart';
import { ExampleQrComponent } from '../pages/exampleqr/example-qr-module';


/**
    * Loads all the local language translation files.
    *
    * @example
    * The TranslateHttpLoader also has two optional parameters:
    * prefix: string = "./assets/i18n/i18n."
    *
    * suffix: string = ".json"
    *
    * By using those default parameters, it will load  translations files for the lang "en" from: ./assets/i18n/i18n.en.json.
     */


export function HttpLoaderFactory(httpClient: HttpClient) {
  return new TranslateHttpLoader(httpClient, './assets/i18n/app/i18n.', '.json');
}

/**
    * Root Module that is bootstrapped to launch the application.
     */
@NgModule({
  declarations: [
    AppComponent,
    AppLayoutComponent,
    LoginComponent,
    DialogComponent,
    LocalizedCurrencyPipe,
    LocalizedDatePipe,
    LoaderComponent,
    AboutUsDialogComponent,
    ChangePasswordDialogComponent,
    ModelDialogComponent,
    ClassModuleComponent,
    DownloadsComponent,
    IntroductionComponent,
    GetStartedComponentQR,
    GetStartedBLEComponent,
    GetStartedEdgeComponent,
    EnumModuleComponent,
    ExampleCardlessComponent,
    ExampleCashlessComponent,
    ExampleCashlessEdgeComponent,
    ExampleQrComponent,
    ExampleAdvancedComponent,
    RSSITablePage,
    CodePipe,
    DecorateDirective,
    SearchBarComponent,
    CopytoclipDirective,
    SnackMessageComponent,
    LandingModuleComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [BrowserModule,
    BrowserAnimationsModule,
    AppMaterialModules,
    FormsModule,
    ReactiveFormsModule,
    AppRoutingModule,
    RouterModule,
    HttpClientModule,
    MatIconModule,
    MatTableModule,
    HttpModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      },
      isolate: true
    })
  ],
  providers: [CustomTranslateService, ServiceFactory, LoginService, CommonService,
    ApiObservablefactory, ApiPromisefactory, DBService, SettingsService, Constants,
     DialogService, MethodServiceJava, MethodServiceSwift, MethodServiceCordova, MethodServiceDart, EnumService, LanguageSettings, SearchDataService
    ],
  bootstrap: [AppComponent],
  entryComponents: [DialogComponent, AboutUsDialogComponent, ChangePasswordDialogComponent,
    SnackMessageComponent]
})
export class AppModule { }
